const stringifySorted = (oldObj) => {
  const obj = oldObj.length || oldObj.length === 0 ? [] : {};
  for (const key of Object.keys(oldObj).sort((a, b) => a.localeCompare(b))) {
    const type = typeof oldObj[key];
    if (type === 'object') {
      obj[key] = stringifySorted(oldObj[key]);
    } else {
      obj[key] = oldObj[key];
    }
  }
  return JSON.stringify(obj);
};

export default class UniqueList {
  constructor() {
    this.map = new Map();
    this[Symbol.iterator] = this.values;
  }

  addList(arr) {
    const callBack = (el) => {
      this.add(el);
    };
    arr.forEach(callBack);
    return this;
  }

  add(item) {
    this.map.set(stringifySorted(item), item);
    if (this.map.size > 4) {
      const [firstKey] = this.map.keys();
      this.delete(this.map.get(firstKey));
    }
    return this;
  }

  values() {
    return this.map.values();
  }

  delete(item) {
    return item && this.map.delete(stringifySorted(item));
  }

  size() {
    return this.map.size;
  }
}

export const convertItemsToArray = (obj, isReverse = false) => {
  for (const item in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, item)) {
      obj[item] = isReverse
        ? Array.from(obj[item].values()).reverse()
        : Array.from(obj[item].values());
    }
  }
  return obj;
};

export const convertItemsToSet = (obj) => {
  for (const item in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, item)) {
      const list = new UniqueList();
      obj[item] = list.addList(obj[item]);
    }
  }
  return obj;
};
